import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Provider as JotaiProvider } from "jotai";
import { DevTools as JotaiDevtools } from "jotai-devtools";
import { AuthProvider } from "@/context/AuthContext";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();

export default function AppProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <QueryClientProvider client={queryClient}>
      <JotaiProvider>
        <AuthProvider>
          {children}
          <ToastContainer />
          <ReactQueryDevtools />
          {/* <JotaiDevtools /> */}
        </AuthProvider>
      </JotaiProvider>
    </QueryClientProvider>
  );
}
